import { render, staticRenderFns } from "./DashboardScenarios.vue?vue&type=template&id=28923140&scoped=true&"
import script from "./DashboardScenarios.vue?vue&type=script&lang=js&"
export * from "./DashboardScenarios.vue?vue&type=script&lang=js&"
import style0 from "./DashboardScenarios.vue?vue&type=style&index=0&id=28923140&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28923140",
  null
  
)

export default component.exports